import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxGym from '../../util/remote/ajaxGym';
import { useTheme } from '../ThemeContext';

const initialState = { 
    mounted: false,
    customerPhoneNumber: '',
    membershipTypeList: false,
    customerInfo: null,
    gymClasses: false,
    scheduledClasses: false,
    dailySessionActivity: false,
    searchTerm: '',
    searchResults: false,
    recentMembers: false,
    frequentMembers: false,
    configListing: null,
    monthlyRevenue: null,
    dailySessionCount: null,
    trainerList: false,
    avatarLibrary: false,
    frequentClasses: false,
    commissionBalances: false,

};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }
};



const GymContext = createContext();

export const GymProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [searching, setSearching] = useState(false);
  const { setSweetDialogInfo } = useTheme();

  useEffect(()=>{
    if(state.searchTerm.length >= 2){
      getSearchResults(state.searchTerm);
    }
  }, [state.searchTerm])

  const storeCustomerPhoneNumber = (phoneNumber)=>{
    dispatch({ type: 'customerPhoneNumber', payload: phoneNumber });
  }

   const getConfig = async (refresh) => {
      if(Array.isArray(state.configListing) && !refresh){
        return;
      }
      const server_response = await ajaxGym.fetchGymConfig([]);
      if(server_response.status === "OK"){
        dispatch({ type: 'configListing', payload: server_response.details });
      }else{
        dispatch({ type: 'configListing', payload: '404' });
      }
    }

  const getMembershipTypes = async () => {
    const server_response = await ajaxGym.fetchMembershipTypes();
    if (server_response.status === "OK") {
      dispatch({ type: 'membershipTypeList', payload: server_response.details });
    } else {
      dispatch({ type: 'membershipTypeList', payload: false });
    }
  }

  const storeCustomerInfo = (data)=>{
    dispatch({ type: 'customerInfo', payload: data });
  }

  const getGymClasses = async () => {
    const server_response = await ajaxGym.fetchClasses();
    if (server_response.status === 'OK') {
      dispatch({ type: 'gymClasses', payload: server_response.details });
    }
    else {
      dispatch({ type: 'gymClasses', payload: '404' });
    }
  };

  const getScheduledClasses = async () => {
    const server_response = await ajaxGym.fetchScheduledClasses();
    if (server_response.status === 'OK') {
      dispatch({ type: 'scheduledClasses', payload: server_response.details });
    }
    else {
      dispatch({ type: 'scheduledClasses', payload: '404' });
    }
  };

  const getDailySessionActivity = async () => {
    const server_response = await ajaxGym.fetchDailySessionActivity();
    if (server_response.status === 'OK') {
      dispatch({ type: 'dailySessionActivity', payload: server_response.details });
    }
    else {
      dispatch({ type: 'dailySessionActivity', payload: '404' });
    }
  };

  const getSearchResults = async (search) => {
    if(searching){ return}
    if(search.length < 2){
      return;
    }
    setSearching(true);
    const server_response = await ajaxGym.searchMember(search);
    setSearching(false);
    if (server_response.status === 'OK') {
      dispatch({ type: 'searchResults', payload: server_response.details });
    }
    else {
      dispatch({ type: 'searchResults', payload: '404' });
    }
  }
  const setSearchTerm = (search) => {
    dispatch({ type: 'searchTerm', payload: search });
  }

  const getRecentMembers = async () => {
    const server_response = await ajaxGym.fetchRecentMembers();
    if (server_response.status === 'OK') {
      dispatch({ type: 'recentMembers', payload: server_response.details });
    }
    else {
      dispatch({ type: 'recentMembers', payload: '404' });
    }
  }

  const getFrequentMembers = async () => {
    const server_response = await ajaxGym.fetchFrequentMembers();
    if (server_response.status === 'OK') {
      dispatch({ type: 'frequentMembers', payload: server_response.details });
    }
    else {
      dispatch({ type: 'frequentMembers', payload: '404' });
    }
  }

  const handleEndSession = async (customerInfo) => {
    const server_response = await ajaxGym.endGymSession(customerInfo.id);
       if (server_response.status === "OK") {
         setSweetDialogInfo(server_response.message, customerInfo.full_name + " has been successfully checked out");
         refreshSessions();
       }else{
        refreshSessions();
       }
  };

  const getMonthlyRevenue = async () => {
    const server_response = await ajaxGym.fetchMonthlyRevenue();
    if (server_response.status === 'OK') {
      dispatch({ type: 'monthlyRevenue', payload: server_response.details });
    }
  }

  const getDailySessionCount = async () => {
    const server_response = await ajaxGym.fetchDailySessionCount();
    if (server_response.status === 'OK') {
      dispatch({ type: 'dailySessionCount', payload: server_response.details });
    }
  }

  const getTrainerList = async () => {
    const server_response = await ajaxGym.fetchActiveTrainers();
    if (server_response.status === 'OK') {
      dispatch({ type: 'trainerList', payload: server_response.details });
    }else{
      dispatch({ type: 'trainerList', payload: '404' });
    }
  }

  const getAvatarLibrary = async () => {
    const server_response = await ajaxGym.fetchAvatarLibrary();
    if (server_response.status === 'OK') {
      dispatch({ type: 'avatarLibrary', payload: server_response.details });
    }
  }

  const getFrequentClasses = async () => {
    const server_response = await ajaxGym.fetchFrequentClasses();
    if (server_response.status === 'OK') {
      dispatch({ type: 'frequentClasses', payload: server_response.details });
    }else{
      dispatch({ type: 'frequentClasses', payload: '404' });
    }
  }

  const getCommissionBalances = async () => {
    const server_response = await ajaxGym.fetchCommissionBalances();
    if (server_response.status === 'OK') {
      dispatch({ type: 'commissionBalances', payload: server_response.details });
    }else{
      dispatch({ type: 'commissionBalances', payload: '404' });
    }
  }

  const refreshSessions = async () => {
    getDailySessionActivity();
    getSearchResults(state.searchTerm);
    getRecentMembers();
    getFrequentMembers();
    getMonthlyRevenue();
    getDailySessionCount();
    getTrainerList();
  }
 
  return(
    <GymContext.Provider value={{
      ...state, 
      dispatch,
      storeCustomerPhoneNumber,
      getMembershipTypes,
      storeCustomerInfo,
      getGymClasses, 
      getScheduledClasses,
      getDailySessionActivity,
      getSearchResults,
      setSearchTerm,
      getRecentMembers,
      getFrequentMembers,
      handleEndSession,
      refreshSessions,
      getConfig,
      getMonthlyRevenue,
      getDailySessionCount,
      getTrainerList,
      getAvatarLibrary,
      getFrequentClasses,
      getCommissionBalances,
      }}>
      {children}
    </GymContext.Provider>
  )

}

export const useGym = ()=>useContext(GymContext);

